import { createElement } from "react";
import { useLocation } from "react-router-dom";
import helper from "script/helperFunctions";

const SmartSidebarNavDropdown = ({ Component, route, children, ...rest }) => {
  const location = useLocation();
  let computedRoute = route;
  if (route) {
    const isActuallyActive = location.pathname === route || location.pathname.startsWith(route + "/");
    if (!isActuallyActive) {
      computedRoute = "IGNORE_" + route;
    }
  }
  return createElement(Component, { ...rest, route: computedRoute }, children);
};

const ElementCreator = (
  config,
  components,
  mapProps,
  index,
  allowedFirms,
  firmId
) => {
  const { _tag, _children, ...props } = config;

  const mappedProps = { ...mapProps(props), key: index };
  const childrenElements = _children
    ? typeof _children === "string"
      ? _children
      : _children.map((c, key) =>
        JsonComponentRenderer(
          c,
          components,
          mapProps,
          key,
          allowedFirms,
          firmId
        )
      )
    : null;

  if (_tag === "CSidebarNavDropdown") {
    return createElement(
      SmartSidebarNavDropdown,
      {
        ...mappedProps,
        Component: components[_tag],
      },
      childrenElements
    );
  }

  return createElement(
    components[_tag],
    mappedProps,
    childrenElements
  );
}

export function JsonComponentRenderer(
  config,
  components,
  mapProps,
  key,
  allowedFirms,
  firmId
) {
  if (typeof components[config] !== undefined)
    if (Array.isArray(config)) {
      return config.map((c, index) =>
        ElementCreator(c, components, mapProps, index, allowedFirms, firmId)
      );
    } else if (helper.isObject(config)) {
      return ElementCreator(
        config,
        components,
        mapProps,
        key,
        allowedFirms,
        firmId
      );
    }
  return <div>Invalid configuration</div>;
}